/**
 * Activity Types
 * Represents learning activity events in the user's activity feed
 */

export type ActivityType =
  | 'course_started'
  | 'course_completed'
  | 'certificate_earned'
  | 'pathway_started'
  | 'pathway_completed';

export interface ActivityItem {
  id: number;
  activityType: ActivityType;
  learningObjectId?: number;
  learningObjectTitle?: string;
  courseType?: string;
  pathwayId?: number;
  pathwayName?: string;
  createdAt: string;
}

export interface ActivityTypeInfo {
  icon: string;
  label: string;
  colorClass: string;
}

export const activityTypeMap: Record<ActivityType, ActivityTypeInfo> = {
  course_started: {
    icon: 'play_circle',
    label: 'Started Course',
    colorClass: 'activity-started',
  },
  course_completed: {
    icon: 'check_circle',
    label: 'Completed Course',
    colorClass: 'activity-completed',
  },
  certificate_earned: {
    icon: 'military_tech',
    label: 'Earned Certificate',
    colorClass: 'activity-certificate',
  },
  pathway_started: {
    icon: 'route',
    label: 'Started Pathway',
    colorClass: 'activity-started',
  },
  pathway_completed: {
    icon: 'flag',
    label: 'Completed Pathway',
    colorClass: 'activity-completed',
  },
};

export function getActivityInfo(type: ActivityType): ActivityTypeInfo {
  return activityTypeMap[type] || {
    icon: 'info',
    label: 'Unknown Activity',
    colorClass: '',
  };
}

// Re-export from shared formatters for backward compatibility
export { formatRelativeTime } from '@/utils/formatters';
